const AS_LAST_USER_LOGGED = '@painel-monitoramento-self-checkouts/last_user_logged';
const AS_USER_TOKEN = '@painel-monitoramento-self-checkouts/user_token';
const AS_USER_DATA = '@painel-monitoramento-self-checkouts/user_data';

export default {
    AS_LAST_USER_LOGGED,
    AS_USER_TOKEN,
    AS_USER_DATA
}